import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/app/dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <main>
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)] text-center">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold max-w-4xl mb-6">
              Transform Your Meetings with AI-Powered Notes
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-2xl mb-8">
              Record, transcribe, and organize your meetings effortlessly. Let AI handle the note-taking while you focus on what matters.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="text-lg">
                <Link to="/sign-up">Start Free Trial</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-lg">
                <Link to="/how-it-works">See How It Works</Link>
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomePage;